import Image from 'next/image';
import DecartLogo from '@/../public/decart-logo.png';

type SocialLinkProps = {
  href: string;
  children: React.ReactNode;
};

const SocialLink = ({ href, children }: SocialLinkProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

const SocialLinks = ({ className = '' }: { className?: string }) => (
  <div className={`flex gap-3 place-items-center ${className}`}>
    <SocialLink href="https://www.reddit.com/r/Sidekick_AI/">
      <svg
        className="size-8 text-white/90 hover:text-orange-500 transition-colors duration-200"
        width="29"
        height="26"
        viewBox="0 0 29 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29 11.6187C29 9.60732 27.3695 7.97689 25.3582 7.97689C24.3509 7.97689 23.4408 8.38755 22.7818 9.04866C20.7452 7.73515 18.1433 6.8981 15.2858 6.76751C15.2875 5.55422 15.831 4.4232 16.7775 3.66383C17.7258 2.90318 18.9505 2.61831 20.1367 2.88178L20.2996 2.91796C20.298 2.95879 20.2935 2.99881 20.2935 3.04004C20.2935 4.719 21.6546 6.08009 23.3335 6.08009C25.0125 6.08009 26.3736 4.719 26.3736 3.04004C26.3736 1.36102 25.0125 0 23.3335 0C22.2539 0 21.3082 0.564331 20.7689 1.41245L20.4775 1.34773C18.8234 0.980189 17.1162 1.37756 15.7942 2.43805C14.4739 3.49727 13.7162 5.07506 13.7144 6.76751C10.8575 6.89804 8.25615 7.73468 6.21979 9.04758C5.56064 8.38634 4.64928 7.97682 3.64176 7.97682C1.6305 7.97689 0 9.60732 0 11.6187C0 13.02 0.792978 14.2341 1.95349 14.8429C1.86536 15.2938 1.81899 15.7547 1.81899 16.2239C1.81899 21.4567 7.49645 25.6988 14.5 25.6988C21.5035 25.6988 27.1809 21.4567 27.1809 16.2239C27.1809 15.755 27.1346 15.2942 27.0466 14.8436C28.2072 14.2347 29 13.0202 29 11.6187ZM23.3335 1.57145C24.1434 1.57145 24.8022 2.23026 24.8022 3.04011C24.8022 3.84989 24.1434 4.50871 23.3335 4.50871C22.5237 4.50871 21.8649 3.84989 21.8649 3.04011C21.8649 2.23026 22.5238 1.57145 23.3335 1.57145ZM1.57138 11.6187C1.57138 10.477 2.50014 9.54827 3.64176 9.54827C4.13071 9.54827 4.5795 9.71955 4.93361 10.0044C3.826 10.9546 2.96851 12.0716 2.4361 13.298C1.9132 12.9224 1.57138 12.3104 1.57138 11.6187ZM22.5263 21.6648C20.4009 23.2528 17.5505 24.1273 14.5 24.1273C11.4496 24.1273 8.59913 23.2528 6.47381 21.6648C4.48549 20.1792 3.39044 18.2469 3.39044 16.2239C3.39044 14.2008 4.48549 12.2685 6.47381 10.7829C8.59913 9.19491 11.4496 8.32033 14.5 8.32033C17.5505 8.32033 20.4009 9.19491 22.5263 10.7829C24.5146 12.2685 25.6096 14.2008 25.6096 16.2239C25.6096 18.2469 24.5146 20.1792 22.5263 21.6648ZM26.5634 13.2971C26.0309 12.0708 25.1735 10.9542 24.0661 10.0041C24.4202 9.71928 24.8692 9.54827 25.3582 9.54827C26.4999 9.54827 27.4286 10.477 27.4286 11.6187C27.4286 12.3103 27.0863 12.9216 26.5634 13.2971Z"
          fill="currentColor"
        />
        <path
          d="M9.86715 15.6699C10.7829 15.6699 11.5253 14.9275 11.5253 14.0117C11.5253 13.0959 10.7829 12.3535 9.86715 12.3535C8.95137 12.3535 8.20898 13.0959 8.20898 14.0117C8.20898 14.9275 8.95137 15.6699 9.86715 15.6699Z"
          fill="currentColor"
        />
        <path
          d="M19.1328 15.6699C20.0486 15.6699 20.7909 14.9275 20.7909 14.0117C20.7909 13.0959 20.0486 12.3535 19.1328 12.3535C18.217 12.3535 17.4746 13.0959 17.4746 14.0117C17.4746 14.9275 18.217 15.6699 19.1328 15.6699Z"
          fill="currentColor"
        />
        <path
          d="M18.4293 18.0389C17.2604 19.1039 15.7451 19.6903 14.1625 19.6903C12.3854 19.6903 10.7389 18.9742 9.52634 17.6737C9.23047 17.3563 8.73329 17.339 8.4159 17.6349C8.0985 17.9308 8.08116 18.428 8.37709 18.7454C9.86823 20.3445 11.9769 21.2616 14.1625 21.2616C16.1376 21.2616 18.0288 20.5296 19.4876 19.2004C19.8083 18.9081 19.8315 18.4112 19.5393 18.0905C19.2471 17.77 18.7505 17.7465 18.4293 18.0389Z"
          fill="currentColor"
        />
      </svg>
    </SocialLink>
    <SocialLink href="https://x.com/DecartAI">
      <svg
        className="h-5 w-5 text-white/90 hover:text-blue-500 transition-colors duration-200"
        viewBox="0 0 23 23"
        fill="none"
      >
        <path
          d="M23 23L14.0056 9.59518L14.0209 9.60773L22.1307 0H19.4206L12.8141 7.82L7.56781 0H0.460204L8.8574 12.5151L8.85638 12.5141L0 23H2.71009L10.055 14.2997L15.8924 23H23ZM6.494 2.09091L19.1138 20.9091H16.9662L4.33615 2.09091H6.494Z"
          fill="currentColor"
        />
      </svg>
    </SocialLink>
    <SocialLink href="https://discord.gg/DyekWJN546">
      <svg
        className="size-8 text-white/90 hover:text-indigo-500 transition-colors duration-200"
        viewBox="0,0,256,256"
        width="100px"
        height="100px"
      >
        <g
          fill="currentColor"
          fillRule="nonzero"
          stroke="none"
          strokeWidth="1"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="10"
          strokeDasharray=""
          strokeDashoffset="0"
          fontFamily="none"
          fontWeight="none"
          fontSize="none"
          textAnchor="none"
          style={{ mixBlendMode: 'normal' }}
        >
          <g transform="scale(5.12,5.12)">
            <path d="M41.625,10.76953c-3.98047,-3.20313 -10.27734,-3.74609 -10.54687,-3.76563c-0.41797,-0.03516 -0.81641,0.19922 -0.98828,0.58594c-0.01562,0.02344 -0.15234,0.33984 -0.30469,0.83203c2.63281,0.44531 5.86719,1.33984 8.79297,3.15625c0.46875,0.28906 0.61328,0.90625 0.32422,1.375c-0.19141,0.30859 -0.51562,0.47656 -0.85156,0.47656c-0.17969,0 -0.36328,-0.05078 -0.52734,-0.15234c-5.03125,-3.12109 -11.3125,-3.27734 -12.52344,-3.27734c-1.21094,0 -7.49609,0.15625 -12.52344,3.27734c-0.46875,0.29297 -1.08594,0.14844 -1.375,-0.32031c-0.29297,-0.47266 -0.14844,-1.08594 0.32031,-1.37891c2.92578,-1.8125 6.16016,-2.71094 8.79297,-3.15234c-0.15234,-0.49609 -0.28906,-0.80859 -0.30078,-0.83594c-0.17578,-0.38672 -0.57031,-0.62891 -0.99219,-0.58594c-0.26953,0.01953 -6.56641,0.5625 -10.60156,3.80859c-2.10547,1.94922 -6.32031,13.33984 -6.32031,23.1875c0,0.17578 0.04688,0.34375 0.13281,0.49609c2.90625,5.10938 10.83984,6.44531 12.64844,6.50391c0.00781,0 0.01953,0 0.03125,0c0.32031,0 0.62109,-0.15234 0.80859,-0.41016l1.82813,-2.51562c-4.93359,-1.27344 -7.45312,-3.4375 -7.59766,-3.56641c-0.41406,-0.36328 -0.45312,-0.99609 -0.08594,-1.41016c0.36328,-0.41406 0.99609,-0.45312 1.41016,-0.08984c0.05859,0.05469 4.69922,3.99219 13.82422,3.99219c9.14063,0 13.78125,-3.95312 13.82813,-3.99219c0.41406,-0.35937 1.04297,-0.32422 1.41016,0.09375c0.36328,0.41406 0.32422,1.04297 -0.08984,1.40625c-0.14453,0.12891 -2.66406,2.29297 -7.59766,3.56641l1.82813,2.51563c0.1875,0.25781 0.48828,0.41016 0.80859,0.41016c0.01172,0 0.02344,0 0.03125,0c1.80859,-0.05859 9.74219,-1.39453 12.64844,-6.50391c0.08594,-0.15234 0.13281,-0.32031 0.13281,-0.49609c0,-9.84766 -4.21484,-21.23828 -6.375,-23.23047zM18.5,30c-1.93359,0 -3.5,-1.78906 -3.5,-4c0,-2.21094 1.56641,-4 3.5,-4c1.93359,0 3.5,1.78906 3.5,4c0,2.21094 -1.56641,4 -3.5,4zM31.5,30c-1.93359,0 -3.5,-1.78906 -3.5,-4c0,-2.21094 1.56641,-4 3.5,-4c1.93359,0 3.5,1.78906 3.5,4c0,2.21094 -1.56641,4 -3.5,4z"></path>
          </g>
        </g>
      </svg>
    </SocialLink>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-[#0f0f0f] pt-14 md:pt-20 py-5 border-t border-border/20">
      <div className="max-w-7xl mx-auto px-5">
        <div className="flex flex-col items-start justify-between gap-6">
          <div className="justify-between w-full flex items-start pt-1">
            <Image
              src={DecartLogo}
              alt="Decart Logo"
              width={120}
              height={28}
              className="h-7 w-auto"
            />
            <SocialLinks />
          </div>

          <div className="flex flex-col gap-4 text-muted-foreground text-sm text-left">
            <p>
              Born from the innovation labs at{' '}
              <a href="https://www.decart.ai" className="text-blue-500">
                Decart AI
              </a>
              , creators of Oasis, Sidekick pushes the boundaries of AI
              interaction. Experience live conversations with AI companions,
              powered by next-generation real-time video and unmatched model
              efficiency.
            </p>
            <p className="text-xs">© 2025 Decart. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
